import React, { useState, useEffect } from 'react'
import { Routes, Route, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import logo from './MPC-Logo.png';
//import beltramiLogo from './logos/beltrami.gif';
import beltramiLogo from './logos/Beltrami/Beltrami-Logo-White.png';
import cassLogo from './logos/Cass-County/CassCounty-Logo-White.png';
import cavalierLogo from './logos/Cavalier/Cavalier-Logo-White.png';
import clearwaterPolkLogo from './logos/Clearwater-Polk/ClearwaterPolk-Logo-White.png';
import nodakLogo from './logos/Nodak/Nodak-Logo-White.png';
import northStarLogo from './logos/North-Star/NorthStar-Logo-White.png';
import pkmLogo from './logos/PKM/PKM-Logo-White.png';
import redLakeLogo from './logos/Red-Lake/RedLake-Logo-White.png';
import redRiverValleyLogo from './logos/Red-River/RedRiver-Logo-White.png';
import roseauLogo from './logos/Roseau/Roseau-Logo-White.png';
import wildRiceLogo from './logos/Wild-Rice/WildRice-Logo-White.png';
import nmpaLogo from './logos/NMPA/NMPA-Logo-White.png';
import './App.css';
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import DemandResponseLogMobile2 from './components/DemandResponseLogMobile2';
import DemandResponsePlans from './components/DemandResponsePlans';
import DemandResponseCurrentDetail from './components/DemandResponseCurrentDetail';
import DemandResponseCurrentSummary from './components/DemandResponseCurrentSummary';
import RippleLastOnOffDetail from './components/RippleLastOnOffDetail';

function App() {

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const queryString = location.search;

  const [hideHeader, setHideHeader] = useState(false);
  const [hideNav, setHideNav] = useState(false);

  useEffect(() => {
    setHideHeader(searchParams.get('hideHeader') === 'true');
    setHideNav(searchParams.get('hideNav') === 'true');
  }, [location.search]);


 const getCoopFromSubdomain = () => {
  const host = window.location.hostname; // e.g., "coop1.domain.com"
  const parts = host.split(".");
  
  // Handle localhost and IPs gracefully
  if (host === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    return "minnkota"; // or any default coop name
  }

  return parts.length > 2 ? parts[0] : "minnkota";
};

  const [selectedCoop, setSelectedCoop] = useState(null);
  
  const coops = ["minnkota", "beltrami", "cass", "cavalier", "cp", "nodak",
                 "northstar", "pkm", "redlake", "redriver", "roseau", "wildrice", "nmpa"];

  const coopLogos = {
    "minnkota": logo,
    "beltrami": beltramiLogo,
    "cass": cassLogo,
    "cavalier": cavalierLogo,
    "cp": clearwaterPolkLogo,
    "nodak": nodakLogo,
    "northstar": northStarLogo,
    "pkm": pkmLogo,
    "redlake": redLakeLogo,
    "redriver": redRiverValleyLogo,
    "roseau": roseauLogo,
    "wildrice": wildRiceLogo,
    "nmpa": nmpaLogo    
  };

  useEffect(() => {
    const subdomainCoop = getCoopFromSubdomain();
    const matchedCoopName = coops.find(c => c.toLowerCase() === subdomainCoop.toLowerCase());

    if (matchedCoopName) {
      setSelectedCoop(matchedCoopName);
    }else{
      setSelectedCoop("minnkota");
    }
  }, [coops]);

  useEffect(() => {
    if (location.pathname === '/') setView('Current Summary');
    else if (location.pathname === '/detail') setView('Current Detail');
    else if (location.pathname === '/log') setView('Today\'s Log');
    else if (location.pathname === '/plans') setView('Demand Response Plans');
  }, [location.pathname]);

  const [view, setView] = useState('Current Summary');

  return (
    <div className="App">
      {/* Header - Hides based on URL Parameter */}
      {!hideHeader && (
        <header className="App-header">
          {/* Coop-logo (Left) */}
          {selectedCoop && (
              <img 
                  src={coopLogos[selectedCoop]} 
                  className="Coop-logo" 
                  alt={`${selectedCoop} logo`} 
              />
          )}
          
          {/* H2 Title (Center) */}
          <h2>
              Demand Response
          </h2>

          {/* App-logo (Right) */}
          <img 
              src={logo} 
              className="App-logo" 
              alt="logo" 
          />
        </header>
      /*<header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        {selectedCoop && <img src={coopLogos[selectedCoop]} className="Coop-logo" alt={selectedCoop} />}
        <h2>
          Demand Response
        </h2>
        
      </header>*/
      )}
      <main>
      {/* Navigation - Hides based on URL Parameter */}
      {!hideNav && (
         <ButtonGroup variant="contained" aria-label="outlined primary button group">
          <Button onClick={() => navigate('/' + queryString)} style={{ backgroundColor: view === 'Current Summary' ? '#007BFF' : '#1E5AB9' }}>
            Current Summary
          </Button>
          <Button onClick={() => navigate('/detail' + queryString)} style={{ backgroundColor: view === 'Current Detail' ? '#007BFF' : '#1E5AB9' }}>
            Current Detail
          </Button>
          <Button onClick={() => navigate('/log' + queryString)} style={{ backgroundColor: view === 'Today\'s Log' ? '#007BFF' : '#1E5AB9' }}>
            Logs
          </Button>
          <Button onClick={() => navigate('/plans' + queryString)} style={{ backgroundColor: view === 'Demand Response Plans' ? '#007BFF' : '#1E5AB9' }}>
            Demand Response Plans
          </Button>
        </ButtonGroup>
        
        )}

        <Routes>
          <Route path="/" element={<DemandResponseCurrentSummary />} />
          <Route path="/detail" element={
            <DemandResponseCurrentDetail
              coop={selectedCoop ?? "minnkota"}
              defaultStartDate={new Date()}
              defaultEndDate={new Date(new Date().setDate(new Date().getDate() + 1))}
            />
          } />
          <Route path="/log" element={
            <DemandResponseLogMobile2
              coop={selectedCoop ?? "minnkota"}
              defaultStartDate={new Date()}
              defaultEndDate={new Date(new Date().setDate(new Date().getDate() + 1))}
            />
          } />
          <Route path="/plans" element={<DemandResponsePlans numPlans={10} />} />
          <Route path="/ripple/:loadGroup" element={<RippleLastOnOffDetail />} />
        </Routes>

      </main>
    </div>
  );
}
export default App;